import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';
const useModal = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const openModal = useCallback((to) => {
        navigate(to, { state: { background: location } });
    }, [navigate, location]);
    const closeModal = useCallback(() => {
        navigate(-1);
    }, [navigate]);
    return { openModal, closeModal };
};
export { useModal };
//# sourceMappingURL=useModal.js.map